import { render } from "./Sleep.vue?vue&type=template&id=32404668&scoped=true"
import script from "./Sleep.vue?vue&type=script&lang=js"
export * from "./Sleep.vue?vue&type=script&lang=js"

import "./Sleep.vue?vue&type=style&index=0&id=32404668&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32404668"],['__file',"src/apps/quiz/routes/Sleep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32404668"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32404668', __exports__)) {
    api.reload('32404668', __exports__)
  }
  
  module.hot.accept("./Sleep.vue?vue&type=template&id=32404668&scoped=true", () => {
    api.rerender('32404668', render)
  })

}


export default __exports__